import { useEffect, useState } from 'react'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { AuthAlert, AuthButton, AuthShell, AuthSpinner } from '@/components/auth/AuthShell'
import { setAccessToken } from '@/utils/auth-token'

export const Route = createFileRoute('/sso-callback')({
  component: SSOCallbackPage,
})

function SSOCallbackPage() {
  const navigate = useNavigate()
  const search = useSearch({ from: '/sso-callback' })
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    // Token is passed in the URL by the backend after successful Google/Apple SSO
    const token = (search as any).token
    const errorMessage = (search as any).error

    if (errorMessage) {
      setError(String(errorMessage))
      return
    }

    if (!token) {
      setError('We could not sign you in with Google. Please try again.')
      return
    }

    // Stored synchronously, before the root route's first request goes out.
    setAccessToken(token)

    // Force a hard redirect to the home page so AuthProvider mounts and auto-fetches the user profile
    window.location.href = '/home'
  }, [search])

  if (error) {
    return (
      <AuthShell title="We could not sign you in">
        <AuthAlert>{error}</AuthAlert>
        <AuthButton onClick={() => navigate({ to: '/login' })}>Back to log in</AuthButton>
      </AuthShell>
    )
  }

  return (
    <AuthShell title="Signing you in…">
      <AuthSpinner />
    </AuthShell>
  )
}
